import { render, staticRenderFns } from "./CharacteristicsTypeahead.vue?vue&type=template&id=6acec57e&scoped=true"
import script from "./CharacteristicsTypeahead.vue?vue&type=script&lang=js"
export * from "./CharacteristicsTypeahead.vue?vue&type=script&lang=js"
import style0 from "./CharacteristicsTypeahead.vue?vue&type=style&index=0&id=6acec57e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acec57e",
  null
  
)

export default component.exports